import StatusBadge from 'components/atoms/status-badge'
import { CURATION_STATUS } from 'domains/seller-market-product/constants'
import PropTypes from 'prop-types'
import React from 'react'

const proptypes = {
  curation_status: PropTypes.string
}

/**
 * To give nice look on Seller Market Product `curation_status`.
 * It maps `curation_status` to certain style and pass to `StatusBadge`.
 * @param {string} curation_status Seller Product price curation_status. available values
 * - `pending`
 * - `accepted`
 * - `rejected`
 */
const SellerMarketProductCurationStatusBadge = ({ curation_status }) => {

  const colorMap = {
    [CURATION_STATUS.PENDING]  : 'warning',
    [CURATION_STATUS.ACCEPTED] : 'success',
    [CURATION_STATUS.REJECTED] : 'danger'
  }

  const color = colorMap[curation_status] || 'default'

  return <StatusBadge color={ color } label={ curation_status } />
}

SellerMarketProductCurationStatusBadge.propTypes = proptypes

export default SellerMarketProductCurationStatusBadge
